import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { City } from '@app/entity/city';
import { API_VERSION } from '@app/core/api.version';
import { ReplaySubject } from 'rxjs/ReplaySubject';
import { Observable } from 'rxjs/Observable';
import { Citizenship } from '@app/entity';

export const DEFAULT_CITY: City = { id: 1, name: 'Москва' };

@Injectable()
export class FederalSubjectsService {
  private citiesStream = new ReplaySubject<City[]>(1);
  cities: Observable<City[]> = this.citiesStream.asObservable();

  private cityStream = new ReplaySubject<City>(1);
  city: Observable<City> = this.cityStream.asObservable();

  defaultCity = DEFAULT_CITY;

  constructor(private http: HttpClient) {
    this.getCities();

    // todo set city from authorized user
    this.cityStream.next(null);
  }

  private getCities() {
    this.http.get<City[]>(`/${API_VERSION}/cities/`)
      .subscribe(cities => this.citiesStream.next(cities));
  }

  setCity(city: City) {
    this.cityStream.next(city);
  }

  getCitizenships(): Observable<Citizenship[]> {
    return this.http.get<Citizenship[]>(`/${API_VERSION}/citizenship/`);
  }

}



// WEBPACK FOOTER //
// ./src/app/core/services/federal-subjects.service.ts